<template>
  <nav class="zi-navbar">
    <div class="navbar__links">
      <router-link
        :to="{ path: '/jacket', query: $route.query }"
        class="navbar__link"
      >
        Edit Jacket
      </router-link>

      <router-link
        :to="{ path: '/patches', query: $route.query }"
        class="navbar__link"
      >
        Edit Patches
      </router-link>

      <router-link
        :to="{ path: '/finalize', query: $route.query }"
        class="navbar__link"
      >
        {{ finalThumbName }}
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation.vue',
  mounted () {
    this.$store.commit('ui/setActiveNavPath', this.path);
  },
  computed: {
    finalThumbName () {
      if (this.$route.query.schoolId) {
        return 'SAVE JACKET';
      }
      return 'PLACE ORDER';
    },

    path () {
      return this.$route.path;
    }
  },
  watch: {
    path () {
      this.$store.commit('ui/setActiveNavPath', this.path);
    }
  },
  methods: {
  },
};
</script>

<style scoped>
  .zi-navbar {
    display: flex;
  }

  .navbar__links {
    background: #cbcaca;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: relative;
    z-index: 10;
  }

  .navbar__link {
    width: 100%;
    background: transparent;
    color: #231f20;
    font-size: 26px;
    font-weight: bold;
    padding: 20px;
    text-decoration: none;
    text-transform: uppercase;
    border-right: 1px solid #fff;
    text-align: center;

    transition: 0.25s ease-in-out all;
  }

  .navbar__link:last-child {
    width: calc(100% + 1px);
    border: none;
  }

  .router-link-active {
    background: #1c539c;
    color: #fff;

    pointer-events: none;
  }

  .navbar__link:hover,
  .link-hover:hover {
    background: #7aa3d8;
    color: #fff;
    cursor: pointer;
  }
</style>
